module.exports = __webpack_public_path__ + "files/6e409ffb14fae893070e1e0d81be0d45.svg";